import { styled, TextareaAutosize } from '@mui/material';

export const TextArea = styled(TextareaAutosize)<{ height?: number }>(
  ({ theme, height }) => ({
    overflow: 'scroll !important',
    height: height ? `${height}px !important` : 'auto',
    borderColor: theme.palette.grey[400],
    fontSize: '14px',
    fontWeight: 500,
    lineHeight: '18px',
    color: theme.palette.grey[800],
    padding: '16px',
    resize: 'none',
    width: '100%',
    '&:hover': {
      borderColor: theme.palette.grey[400],
    },
    '&::-moz-placeholder': {
      color: theme.palette.grey[500],
    },
    '&::-webkit-input-placeholder': {
      color: theme.palette.grey[500],
    },
    '&:focus': {
      outline: 0,
      borderColor: theme.palette.grey[400],
    },
    '&:focus-visible': {
      outline: 0,
    },
  })
);
